export const COLOR = {
    BASE: {
        PAGE: '#000000',
        DIVIDER: '#e4e5e7',
        DIVIDER1: '#0e3c67',
        DIVIDER2: '#071d33',
        SCRIM_LIGHT: 'rgba(0, 0, 0, 0.6)',
        SCRIM_DARK: 'rgba(0, 0, 0, 0.8)',
        SHADOW_SHORT: 'rgba(0, 0, 0, 0.3)',
        SHADOW_LONG: 'rgba(0, 0, 0, 0.5)',
    },
    BRAND: {
        BACKGROUND1: '#071d33',
        BACKGROUND2: '#c6ddf3',
        BACKGROUND3: '#1c78ce',
        BACKGROUND4: '#0e3c67',
        BACKGROUND5: '#051321',
        BACKGROUND6: '#000000',
        BACKGROUND7: '#092844',
        FOREGROUND1: '#ffffff',
        FOREGROUND2: '#ffffff',
        FOREGROUND3: '#c6ddf3',
        FOREGROUND4: '#5e5e5e',
        FOREGROUND5: '#dddddd',
        FOREGROUND6: '#051321',
        FOREGROUND7: '#f2f2f2',
        ACCENT1: '#84d7f7',
        ACCENT2: '#ffffff',
        ACCENT3: '#c6ddf3',
        CTA1: '#1CCE72',
        CTA2: '#2776cf',
    },
    SEMANTIC: {
        ERROR1: '#f36a60',
        ERROR2: '#f79c95',
        WARNING1: '#ffdd6c',
        WARNING2: '#ffe99d',
        SUCCESS1: '#009d4f',
        SUCCESS2: '#80cea7',
    },
    RESERVED: {
        BLACK: '#2d2d2e',
        WHITE: '#f9f9f9',
        TRANSPARENT: 'rgba(249, 249, 249, 0)',
    },
};

export const FONT = {
    FAMILY: 'Montserrat, sans-serif',

    WEIGHT_NORMAL: 400,
    WEIGHT_MEDIUM: 500,
    WEIGHT_SEMI_BOLD: 600,
    WEIGHT_BOLD: 900,

    SIZE_XXSMALL: 12,
    SIZE_XSMALL: 12,
    SIZE_SMALL: 13,
    SIZE_MEDIUM: 14,
    SIZE_LARGE: 16,
    SIZE_XLARGE: 18,
};

export const BASIC_PALETTE = {
    FONT_FAMILY: 'Montserrat, sans-serif',

    FONT_HEADER4: {
        fontSize: FONT.SIZE_LARGE,
        fontWeight: FONT.WEIGHT_SEMI_BOLD,
        textTransform: 'uppercase',
    },
    FONT_BODY_MEDIUM: {
        fontSize: 14,
        fontWeight: 600,
    },

    FILL_PAGE: COLOR.BASE.PAGE,
    FILL_HEADER: COLOR.BRAND.BACKGROUND1,
    FILL_HERO: COLOR.BRAND.BACKGROUND1,
    FILL_SHEET: COLOR.BRAND.BACKGROUND1,
    FILL_POPOVER: COLOR.BRAND.FOREGROUND6,

    FILL_CONTENT_DEFAULT: COLOR.BRAND.BACKGROUND1,
    FILL_CONTENT_PROMINENT: COLOR.BRAND.BACKGROUND1,

    FILL_CARD: COLOR.BRAND.BACKGROUND1,
    FILL_CARD_PROMINENT: COLOR.BRAND.BACKGROUND1,

    FILL_CONTROL_OUTLINE: `${COLOR.BRAND.FOREGROUND7}|${COLOR.BRAND.FOREGROUND1}`,
    FILL_CONTROL_ACCENT: COLOR.BRAND.ACCENT3,
    FILL_CONTROL_ODDS: COLOR.BRAND.BACKGROUND5,

    FILL_ACCENT_PRIMARY: '#00ce72',
    FILL_ACCENT_SECONDARY: '#84d7f7',
    FILL_ACCENT_FOCUS: COLOR.BRAND.CTA2,

    FILL_SELECTED_PRIMARY: COLOR.BRAND.ACCENT3,
    FILL_SELECTED_ODDS: COLOR.BRAND.ACCENT2,

    DEFAULT_PRIMARY_TEXT: `${COLOR.BRAND.FOREGROUND7}|${COLOR.BRAND.FOREGROUND1}`,
    DEFAULT_SECONDARY_TEXT: `${COLOR.BRAND.FOREGROUND7}|${COLOR.BRAND.FOREGROUND2}`,

    TEXT_ODDS_PRIMARY: '#ffffff',
    TEXT_ODDS_SECONDARY: '#c6ddf3',

    TEXT_ACCENT_PRIMARY: '#000000',
    TEXT_ACCENT_SECONDARY: '#000000',
    TEXT_ACCENT_FILL: '#c6ddf3',

    TEXT_SELECTED_ODDS: COLOR.BRAND.FOREGROUND6,

    DEFAULT_GENERIC_ACCENT_COLOR: COLOR.BRAND.CTA2,
    DEFAULT_DIVIDER: COLOR.BASE.DIVIDER1,

    DEFAULT_BUTTON_BORDER_RADIUS: 4,
};
